import { Button } from '@/components/ui/button';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type { EmailAccount } from './types';

interface AccountTableProps {
  accounts: EmailAccount[];
  onRemoveAccount: (accountId: string) => void;
  accountPrice: number; // cents
  currencySymbol?: string;
}

export function AccountTable({
  accounts,
  onRemoveAccount,
  accountPrice,
  currencySymbol = '$',
}: AccountTableProps) {
  return (
    <div className="space-y-3">
      {accounts.length === 0 ? (
        <p className="text-sm text-muted-foreground italic py-4 text-center">
          No accounts added yet
        </p>
      ) : (
        <div className="bg-card rounded-card p-1">
          <Table className="[&_thead]:bg-table-header [&_tbody]:bg-table">
            <TableHeader>
              <TableRow className="after:left-6 after:right-6">
                <TableHead className="px-6 py-3 h-10 text-xs">Email Address</TableHead>
                <TableHead className="px-6 py-3 h-10 text-xs">Persona</TableHead>
                <TableHead className="px-6 py-3 h-10 text-xs text-right">Price</TableHead>
                <TableHead className="w-12 px-4 py-3 h-10"></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {accounts.map((account) => (
                <TableRow key={account.id} className="after:left-6 after:right-6">
                  <TableCell className="text-foreground text-xs px-6 py-2.5">
                    {account.email}
                  </TableCell>
                  <TableCell className="text-foreground text-xs px-6 py-2.5">
                    {account.personaFirstName} {account.personaLastName}
                  </TableCell>
                  <TableCell className="text-foreground text-xs px-6 py-2.5 text-right tabular-nums">
                    {currencySymbol}{(accountPrice / 100).toFixed(2)}
                  </TableCell>
                  <TableCell className="px-4 py-2.5">
                    <Button
                      variant="destructive"
                      size="sm"
                      onClick={() => onRemoveAccount(account.id)}
                      className="h-7 px-2 text-xs !shadow-none opacity-50 hover:opacity-70"
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}

    </div>
  );
}
